import React from 'react';

const QuoteBgInverse: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 100" {...props}>
    <path fill="currentColor" d="M0 0h100v100H0z"></path>
    <path
      fill="#fff"
      d="M24 71V58.919c0-3.514.662-7.135 1.985-10.865a48.759 48.759 0 015.24-10.54c2.17-3.352 4.551-6.19 7.145-8.514l10.638 6.324c-1.906 3.244-3.546 6.73-4.922 10.46-1.377 3.73-2.065 8.108-2.065 13.135V71H24zm26.992 0V58.919c0-3.514.662-7.135 1.985-10.865a48.754 48.754 0 015.24-10.54c2.17-3.352 4.552-6.19 7.145-8.514L76 35.324c-1.905 3.244-3.546 6.73-4.922 10.46-1.376 3.73-2.064 8.108-2.064 13.135V71H50.992z"
    ></path>
  </svg>
);

export default QuoteBgInverse;
